import React from 'react';

import { useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import type { SearchGraphResultProps } from '../../../../../../../common/types';
import { LastModified } from '../../../../../../../common/ui/last-modified';
import { SearchResult } from '../../../../../../../common/ui/search-result';
import { enrichExcerpt } from '../../../../../../../common/utils/search-result-utils';
import type { searchGraphCustomerContact_AtlassianSearchPage$key } from './__generated__/searchGraphCustomerContact_AtlassianSearchPage.graphql';
import { messages } from './messages';

export const SearchGraphCustomerContact = ({
	node,
	position,
	cloudId,
	selectedProduct,
	primaryProduct,
	primarySubProduct,
	appMode,
	product,
	icon,
	onResultClicked,
	onResultContextMenu,
	onCopyLinkButtonClicked,
	onSummarizeInChatButtonClicked,
	onContextMenuCopyButtonClicked,
	onContextMenuButtonClicked,
	mainContentWidth,
	selectedSites,
	productConfigs,
}: SearchGraphResultProps<searchGraphCustomerContact_AtlassianSearchPage$key>): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const data = useFragment(
		graphql`
			fragment searchGraphCustomerContact_AtlassianSearchPage on SearchResultGraphDocument {
				__typename
				id
				url
				lastModifiedDate
				entity {
					... on ExternalCustomerContact {
						accountName
						contactUser {
							thirdPartyUser {
								name
								extendedProfile {
									jobTitle
								}
							}
						}
					}
				}
			}
		`,
		node,
	);

	const { id, url, lastModifiedDate, entity } = data;

	const lastModifiedComponent = <LastModified lastModified={lastModifiedDate} />;

	const accountName = entity?.accountName;

	const thirdPartyUser = entity?.contactUser?.thirdPartyUser;

	const title = thirdPartyUser?.name;

	const headerMetadataParts = [
		formatMessage(messages.eventLabel),
		['account-name', accountName],
		['last-modified', lastModifiedComponent],
	];

	return (
		<SearchResult
			productConfigs={productConfigs}
			id={id}
			product={product}
			productSelected={!!selectedProduct}
			onResultClicked={onResultClicked}
			onResultContextMenu={onResultContextMenu}
			onCopyLinkButtonClicked={onCopyLinkButtonClicked}
			onSummarizeInChatButtonClicked={onSummarizeInChatButtonClicked}
			onContextMenuCopyButtonClicked={onContextMenuCopyButtonClicked}
			onContextMenuButtonClicked={onContextMenuButtonClicked}
			icon={icon}
			description={thirdPartyUser?.extendedProfile?.jobTitle}
			headerMetadataParts={headerMetadataParts}
			title={enrichExcerpt(title)}
			url={url}
			isThirdParty
			cloudId={cloudId}
			primaryProduct={primaryProduct}
			primarySubProduct={primarySubProduct}
			position={position}
			partial={data}
			appMode={appMode}
			mainContentWidth={mainContentWidth}
			selectedSites={selectedSites}
		/>
	);
};
